import React from 'react'

import { useFooterContext } from '../FooterContext'
import S from './Logo.styled'
import Link from '../../../modules/link/Link'
import { useEnvDomain } from '../../../hooks'
import languages from '../../../../languages'
import { CrLogo } from '../../Svg'

const Logo = () => {
  const url = useEnvDomain()
  const lang = useFooterContext()?.lang

  const langObj = languages[lang] ? languages[lang].footer : languages.en.footer
  const {
    accessibility: { homeAriaLabel },
  } = langObj

  return (
    <S.Logo className="cr-logo">
      <Link to={url} blank aria-label={homeAriaLabel}>
        <CrLogo className="cr-logo-svg" aria-hidden="true" />
      </Link>
    </S.Logo>
  )
}

export default Logo
